// Google Ads conversion tracking helpers.
// Conversion ID AW-11523972363 is installed in public/index.html.

const ADS_ID = "AW-11523972363";
const QUOTE_LABEL = "WF7jCOH2-r4aEIu6h_cq"; // "Request Quote" conversion action
const CONTACT_LABEL = "dAJ6CLTcuf0ZEIu6h_cq"; // "Contact" conversion action (phone taps)

function fire(args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", args);
  }
}

export function trackQuoteSubmit() {
  fire({ send_to: `${ADS_ID}/${QUOTE_LABEL}` });
}

// Phone taps on the website. These are the lead the owners actually describe
// ("the phone rings"), and until now they were invisible: this pushed
// {event:"phone_click"} to window.dataLayer, which only becomes a conversion
// if Google Tag Manager is installed and configured to listen for it. This
// site loads gtag directly (AW-... in public/index.html) and has no GTM
// container, so nothing consumed the event and Google Ads recorded zero
// website calls for months while the business was taking them daily.
//
// It now fires the "Contact" conversion action, which is a WEBPAGE-type action
// and therefore CAN be triggered from here. The two call actions in the account
// ("Clicks to call", "Calls from ads") are Google-hosted and count only taps on
// the ad's own call asset - they can never be fired by site code, so they are
// not a substitute for this.
//
// The dataLayer push is kept so a future GTM container still sees the event.
export function trackPhoneClick() {
  fire({ send_to: `${ADS_ID}/${CONTACT_LABEL}` });
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "phone_click" });
  }
}
